<app-mu-sidebar
  customClass="express-add-card-modal-anchor express-add-card-content"
  [contentClass]="customClass"
  [flagList]="flagList"
  [showFlag]="showFlag"
  *ngIf="formData"
>
  <form class="p-grid mu-form-content" [formGroup]="formData" appValidator autocomplete="off">
    <app-mu-form-section [gridSizeForm]="12" class="mu-full-width" [withAbsoluteButtons]="true">
      <div class="p-grid">
        <div class="p-col-12 p-md-8 p-lg-8 p-xl-6 express-card express-m-t mu-without-padding">
          <div
            class="p-grid express-container-card"
            [ngClass]="{
              visa: creditCardFranchiseEnum.VISA === franchise,
              mastercard: creditCardFranchiseEnum.MASTERCARD === franchise,
              amex: creditCardFranchiseEnum.AMEX === franchise
            }"
          >
            <div class="p-col-12 p-col-align-center container-number-card">
              <span class="express-number-card">{{ formData.get('cardNumber').value || 'form.placeholder.cardNumber' | translate }}</span>
            </div>
            <div class="p-col-12 p-col-align-center container-date-card">
              <span class="express-data-card">{{ formData.get('expiration').value || 'form.placeholder.validity' | translate }}</span>
            </div>
            <div class="p-col-12 container-date-card">
              <span class="express-data-card" *ngIf="formData.get('names').value || formData.get('surnames').value; else placeholder">{{
                formData.get('names').value + ' ' + formData.get('surnames').value
              }}</span>
              <ng-template #placeholder>
                <span class="express-data-card"
                  >{{ 'form.placeholder.cardHolderNames' | translate }} {{ 'form.placeholder.cardHolderSurNames' | translate }}</span
                >
              </ng-template>
            </div>
          </div>
        </div>

        <div class="p-col-12 p-md-4 p-lg-4 p-xl-6 express-m-t mu-without-padding express-img-kushki">
          <div class="p-grid">
            <div class="p-col-12 container-img">
              <img class="img-kushki" src="/assets/images/logo-kushki.png" alt="logo-kushki" />
            </div>
          </div>
        </div>

        <div class="p-col-12 mu-without-padding express-img-kushki-mobile">
          <div class="p-grid">
            <div class="p-col-6 container-img-mobile">
              <img class="img-kushki-mobile" src="/assets/images/logo-kushki.svg" alt="logo-kushki" />
            </div>
            <div class="p-col-6 container-img-logos">
              <img class="img-kushki-mobile" src="/assets/images/logo-credit-cards.svg" alt="logo-kushki" />
            </div>
          </div>
        </div>

        <div class="p-col-12 add-card-title">
          <span>{{ 'common.payment.newCreditCard' | translate }}</span>
        </div>

        <app-mu-form-fieldset label="cardNumber" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.START">
          <p-inputMask
            pInputText
            type="text"
            id="cardNumber"
            name="cardNumber"
            placeholder="{{ 'form.placeholder.cardNumber' | translate }}"
            formControlName="cardNumber"
            mask="9999 9999 9999 9999"
            slotChar=""
            autoFocus="true"
            [autoClear]="false"
            minlength="18"
          ></p-inputMask>
        </app-mu-form-fieldset>

        <app-mu-form-fieldset
          label="validity"
          [customGridColMd]="6"
          [customGridCol]="4"
          [slimPadding]="true"
          [position]="fieldPosition.MIDDLE"
          class="express-p-r"
        >
          <p-inputMask
            pInputText
            type="text"
            id="expiration"
            name="expiration"
            placeholder="{{ 'form.placeholder.validity' | translate }}"
            formControlName="expiration"
            mask="99/99"
            slotChar=""
            autoFocus="true"
            (onBlur)="checkExpiration()"
          ></p-inputMask>
        </app-mu-form-fieldset>

        <app-mu-form-fieldset
          label="cvv"
          [customGridColMd]="6"
          [customGridCol]="2"
          [slimPadding]="true"
          [position]="fieldPosition.END"
          class="express-p-l"
        >
          <input
            pInputText
            type="password"
            id="cvv"
            name="cvv"
            placeholder="{{ 'form.placeholder.cvv' | translate }}"
            formControlName="cvv"
            maxlength="4"
          />
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="cardHolderNames" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.START">
          <input
            pInputText
            type="text"
            id="names"
            name="names"
            placeholder="{{ 'form.placeholder.cardHolderNames' | translate }}"
            formControlName="names"
          />
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="cardHolderSurNames" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.END">
          <input
            pInputText
            type="text"
            id="surnames"
            name="surnames"
            placeholder="{{ 'form.placeholder.cardHolderSurNames' | translate }}"
            formControlName="surnames"
          />
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="documentType" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.START">
          <app-mu-form-dropdown
            [formGroup]="formData"
            [field]="'documentTypeCard'"
            [optionList]="documentTypeList"
            [filter]="false"
          ></app-mu-form-dropdown>
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="documentNumber" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.END">
          <input
            pInputText
            type="text"
            id="documentNumberCard"
            name="documentNumberCard"
            placeholder="{{ 'form.placeholder.documentNumber' | translate }}"
            formControlName="documentNumberCard"
          />
        </app-mu-form-fieldset>

        <app-mu-form-fieldset label="email" [customGridCol]="6" [slimPadding]="true" [position]="fieldPosition.START">
          <input
            pInputText
            type="text"
            id="emailCard"
            name="emailCard"
            placeholder="{{ 'form.placeholder.email' | translate }}"
            formControlName="emailCard"
          />
        </app-mu-form-fieldset>

        <app-mu-form-buttons [customGridCol]="12" [alwaysFullWidth]="false">
          <p-button
            id="secureServer"
            muButtonLeft
            [label]="'form.button.secureServer' | translate"
            class="mu-button mu-button-full-width button-label"
            type="button"
            icon="fas fa-lock"
            iconPos="left"
            [pTooltip]="'common.payment.tooltipSecureServer' | translate"
            tooltipPosition="top"
            tooltipStyleClass="mu-tooltip-large mu-express-tooltip"
          >
            <span></span>
          </p-button>
          <p-button
            muButtonRight
            [label]="'form.button.saveCard' | translate"
            class="mu-button mu-button-full-width button-submit"
            type="button"
            (click)="save()"
            [disabled]="formData.get('isInvalidForm').value"
          >
            <app-loading [showLoading]="flagList?.get(loaderFlag)" type="icon"></app-loading>
          </p-button>
        </app-mu-form-buttons>
      </div>
    </app-mu-form-section>
  </form>
</app-mu-sidebar>
